<template>
  <div
    :class="[bem.b(), bem.is('expanded', expanded), prepareClassNames()]"
    :style="{
      ...prepareStyles(),
    }"
  >
    <div :class="bem.e('header')">
      <div :class="bem.e('title')">
        <slot name="title-prepend"></slot>
        <slot name="title" :title="title">
          {{ title }}
        </slot>
        <div v-if="showDownUp" :class="bem.e('toggle')" @click="toggleState">
          {{ expanded ? t('ep.title.collapse') : t('ep.title.expand') }}
          <el-icon>
            <ArrowDown />
          </el-icon>
        </div>
        <slot name="title-append"></slot>
      </div>
      <div :class="bem.e('buttons')">
        <slot name="buttons-prepend"></slot>
        <EpButtons :list="buttons" />
        <slot name="buttons-append"></slot>
      </div>
    </div>
    <div
      ref="contentRef"
      :class="[bem.e('content'), bem.is('expanded', expanded)]"
    >
      <slot></slot>
      <!-- <div :class="[bem.e('content-inner')]">
      </div> -->
    </div>
  </div>
</template>
<script setup lang="ts">
import { createNameSpace } from '@el-plus/utils/bem'
import { titleProps, titleEmits } from './title'
import { prepareClassNames, prepareStyles } from '@el-plus/utils/props'
import EpButtons from '@el-plus/components/buttons'
import { useTitle } from './use-title'
import { ArrowDown } from '@element-plus/icons-vue'
import { ElIcon } from 'element-plus'
import { useLocale } from '@el-plus/hooks/use-locale'
const { t } = useLocale()
defineOptions({
  name: 'EpTitle',
  inheritAttrs: false,
})
const bem = createNameSpace('title')
const props = defineProps(titleProps)
const emit = defineEmits(titleEmits)
const { expanded, toggleState } = useTitle(emit)
</script>
